
// export default Sidebar;
import React, { useState } from 'react';
import {
    AlertFilled,
    ShoppingCartOutlined,
    ReconciliationOutlined,
    BranchesOutlined,
    BarChartOutlined,
    EyeOutlined,
    CodeSandboxOutlined,
    SecurityScanFilled,
    DropboxOutlined,
    SkinFilled,
    BackwardFilled,
    ForwardFilled,
    FastBackwardFilled,
    LeftCircleFilled,
    ReconciliationFilled,
    FileProtectOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import '../../src/App.css';

const { Sider } = Layout;

const Sidebar = ({ collapsed, onLogout, userData }) => {
    const location = useLocation();
    const [selectedKey, setSelectedKey] = useState();

    const dept = userData?.dept; // <--- IMPORTANT

    // ----------------------------------------------------------
    // SMART TLS MENU (ONLY VISIBLE FOR dept 18)
    // ----------------------------------------------------------
    const smartTLSMenu = [
        {
            key: "smart-tls",
            icon: <AlertFilled />,
            label: "Smart TLS",
            children: [
                { key: "smart-tls-rovingqc", link: "/tlsreport/rovingqcreport", label: "Day Report" },
                { key: "smart-tls-tlsboard", link: "/tlsreport/tlsboard", label: "TLS Board" },
                { key: "smart-tls-managestaff", link: "/tlsreport/managestaff", label: "Manage Staff" },
            ]
        }
    ];

    // ----------------------------------------------------------
    // OLD MENUS (remove Smart TLS if dept == 11)
    // ----------------------------------------------------------
    const oldMenus = {
        "20": [
            { key: "eol-dashboard", icon: <BarChartOutlined />, link: "/eol-dashboard", label: "EOL Dispatch Dashboard" },
            { key: "dispatch-centre", icon: <SkinFilled />, link: "/eol-dispatch-centre", label: "EOL Dispatch" },
            { key: "manage-bin", icon: <ShoppingCartOutlined />, link: "/manage-bin", label: "Manage Bin" },
            { key: "eol-view-bin", icon: <DropboxOutlined />, link: "/eol/View", label: "View Bin" },
            { key: "eol-bin-master", icon: <SecurityScanFilled />, link: "/eol/bin-master", label: "Bin Status" },
            {
                key: "sub-report", icon: <ReconciliationFilled />, label: "EOL Dispatch Report", children: [
                    { key: "report-daily", link: "/report/daily", label: "Daily Report" },
                    { key: "report-summary", link: "/report/summary", label: "Summary" },
                    { key: "active-kanban", link: "/active/kanban", label: "Active Kanban" },
                ]
            }
        ],
        "21": [
            { key: "manage-bin", icon: <ShoppingCartOutlined />, link: "/manage-bin", label: "Manage Bin" },
            { key: "dispatch-view-bin", icon: <EyeOutlined />, link: "/view-bin", label: "View Bin" },
            { key: "bin-bulk-outward", icon: <FastBackwardFilled />, link: "/dispatch/bulkscan", label: "Bin Bulk Outward" },
            { key: "dispatch-bin-master", icon: <SecurityScanFilled />, link: "/dispatch/bin-master", label: "Bin Status" },
            { key: "wash-outward-bin", icon: <BackwardFilled />, link: "/wash/outward-bin", label: "Bin Outward" },
            {
                key: "ds-report", icon: <ReconciliationOutlined />, label: "Report", children: [
                    { key: "dispatch-bin-status", link: "/dispatch/bin/status", label: "Inward/ Outward Bin" },
                    { key: "report-daily", link: "/report/daily", label: "Daily Report" },
                    { key: "report-summary", link: "/report/summary", label: "Summary" },
                    { key: "active-kanban", link: "/active/kanban", label: "Active Kanban" },
                ]
            }
        ],
        "22": [
            { key: "wash-dashboard", icon: <ShoppingCartOutlined />, link: "/wash/dashboard", label: "Manage Bin" },
            { key: "wash-intransit", icon: <BranchesOutlined />, link: "/wash/dashboard/intransit", label: "Bin Intransit" },
            { key: "wash-view-bin", icon: <EyeOutlined />, link: "/view-bin", label: "View Bin" },
            { key: "wash-bin-master", icon: <SecurityScanFilled />, link: "/wash/bin-master", label: "Bin Status" },
            { key: "wash-inward-bin", icon: <ForwardFilled />, link: "/wash/bin/inward", label: "Bin Inward" },
            { key: "wash-outward-sendtowash", icon: <BackwardFilled />, link: "/wash/bin/sendtogsm", label: "Bin Outward" },
            {
                key: "wash-report", icon: <ReconciliationOutlined />, label: "Report", children: [
                    { key: "wash-bin-status", link: "/wash/bin/status", label: "Inward/ Outward Bin" },
                ]
            }
        ],
        "23": [
            { key: "gsm-bin-dashboard", icon: <ShoppingCartOutlined />, link: "/gsm/bin/dashboard", label: "Manage Bin" },
            { key: "gsm-intransit", icon: <BranchesOutlined />, link: "/gsm/dashboard/transit", label: "Bin Intransit" },
            { key: "gsm-view-bin", icon: <EyeOutlined />, link: "/view-bin", label: "View Bin" },
            { key: "gsm-bin-master", icon: <SecurityScanFilled />, link: "/gsm/bin-master", label: "Bin Status" },
            { key: "gsm-bin-inward", icon: <ForwardFilled />, link: "/gsm/bin/inward", label: "Bin Inward" },
            { key: "wash-outward-bin", icon: <BackwardFilled />, link: "/gsm/outward-bin", label: "Bin Outward" },
            {
                key: "gsm-report", icon: <ReconciliationOutlined />, label: "Report", children: [
                    { key: "gsm-bin-status", link: "/gsm/bin/status", label: "Inward/ Outward Bin" },
                ]
            }
        ],
        "24": [
            { key: "kanban-count-accuracy", icon: <BarChartOutlined />, link: "/kca/dashboard", label: "Dashboard" },
            { key: "kca-kanban-sent-finishing", icon: <EyeOutlined />, link: "/kca/kanban-sent-finishing", label: "Sent To Finishing" },
            {
                key: "kca-report", icon: <ReconciliationOutlined />, label: "Report", children: [
                    { key: "kca-daily-report", link: "/kca/daily-report", label: "Daily Report" },
                ]
            }
        ],
        "11": [
            { key: "eolc-dashboard", icon: <BarChartOutlined />, link: "/eolc/dashboard", label: "EOL Checker" },
            {
                key: "eolc-report",
                icon: <ReconciliationOutlined />,
                label: "Report",
                children: [
                    { key: "eolc-hour-report", link: "/report/hour-report", label: "Hourly Report" },
                ]
            },
            {
                key: "eolc-critical-report",
                icon: <AlertFilled />,
                label: "Critical Operation",
                children: [
                    { key: "eolc-dummy-operation", link: "/report/dummy-operation", label: "Time History" },
                    { key: "eolc-critical-operation", link: "/report/critical-operation", label: "Garments Production" },
                    { key: "eolc-target-report", link: "/report/target-report", label: "CO Dashboard" },
                ]
            },
            { key: "eolc-review", icon: <CodeSandboxOutlined />, link: "/eolc/barcodereview", label: "Review" },
            { key: "capa-report", icon: <FileProtectOutlined />, link: "/eolc/capareport", label: "CAPA Report" },

            // REMOVE SMART TLS HERE
            // { key: "smart-tls", ... } ❌ removed
        ]
    };

    // ----------------------------------------------------------
    // FINAL MENU LOGIC
    // ----------------------------------------------------------
    let finalMenu = [];

    if (dept === "18") {
        // ONLY SMART TLS
        finalMenu = smartTLSMenu;
    } 
    else if (dept === "11") {
        // OLD menu without Smart TLS
        finalMenu = oldMenus["11"];
    } 
    else {
        // Default old menus for other departments
        finalMenu = oldMenus[dept] || [];
    }

    return (
        <Sider collapsible collapsed={collapsed} style={{ backgroundColor: '#055e88' }} width={235} collapsedWidth={80}>
            {!collapsed && (
                <div
                    style={{
                        height: '8px',
                        margin: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '30px',
                        color: 'white',
                        padding: '20px',
                    }}
                >
                    SMART
                </div>
            )}
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[selectedKey]}
                onClick={(e) => setSelectedKey(e.key)}
                style={{ backgroundColor: '#055e88', fontWeight: 'bold', color: 'white' }}
            >
                {finalMenu.map(item =>
                    item.children ? (
                        <Menu.SubMenu key={item.key} title={item.label} icon={item.icon}>
                            {item.children.map(sub => (
                                <Menu.Item key={sub.key}><Link to={sub.link}>{sub.label}</Link></Menu.Item>
                            ))}
                        </Menu.SubMenu>
                    ) : (
                        <Menu.Item key={item.key} icon={item.icon}>
                            <Link to={item.link}>{item.label}</Link>
                        </Menu.Item>
                    )
                )}

                <Menu.Item key="logout" icon={<LeftCircleFilled />} onClick={onLogout}>
                    <Link to="/logout">Log Out</Link>
                </Menu.Item>
            </Menu>
        </Sider>
    );
};

export default Sidebar;
